import { Component, OnInit } from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';

@Component({
  selector: 'app-page-thank',
  templateUrl: './page-thank.component.html',
  styleUrls: ['./page-thank.component.scss']
})
export class PageThankComponent implements OnInit {
  
  
  
  public orderNumber = null;
  public status = null;
  public message = '';
  public text = '';

  resetForm = () => {
    localStorage.removeItem('order_id');
    window.location.href = '/';
  }

  constructor(private UIService: UiService,private apiService: ApiService) {
    
  }
  ngOnInit() {
   let orderNumber = localStorage.getItem('order_id');
    if(orderNumber){
      this.orderNumber = orderNumber;
      let checker = this.apiService.checkPaymentStatus(orderNumber).subscribe(value => {
        this.status = value['status'];
        this.message = value['message'];
        if(this.status !== 200) {
            this.text = 'Что то пошло не так =(';
            localStorage.removeItem('order_id');
        } else {
          this.text = 'Ваш заказ успешно отправлен, наши менеджеры скоро с Вами свяжутся';
          localStorage.removeItem('order_id');
        }
      });
    }
  }
}
